var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-3 grey lighten-1 justify-center",attrs:{"dark":""}},[_c('div',{staticClass:"brand-container"},[_c('span',{staticClass:"caption"},[_vm._v("Powered by")])])])}
var staticRenderFns = []

export { render, staticRenderFns }